import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import SubHeader from '../components/header/SubHeader'
import NavTab from '../components/header/NavTab'
import styles from '../utils/mainStyle';

const useStyles = makeStyles((theme) => ({
  ...styles
}));

const Minimal = props => {
  const { children } = props;
  const { displayName } = props;
  const classes = useStyles();
  return (
      <React.Fragment>  
      <main className={classes.main}>
          {children}
      </main>
      </React.Fragment>
    
  );
};

Minimal.propTypes = {
  children: PropTypes.node
};

export default Minimal;
